import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'sale4all_hide_demo_pages';

/**
 * Controls whether the Vex demo/template pages (Help Center, Calendar,
 * Social, WYSIWYG Editor, Scrumboard, Authentication demo pages, Errors,
 * Pricing, Invoice, FAQ, Guides, UI Elements, Documentation) are hidden
 * from the sidebar navigation.
 *
 * Defaults to hidden (true). The value is persisted to localStorage so it
 * survives a page reload, and can be flipped live from the Configuration
 * panel without a rebuild.
 */
@Injectable({
  providedIn: 'root'
})
export class NavigationVisibilityService {
  private readonly _hideUnneededPages = new BehaviorSubject<boolean>(
    this.readInitialValue()
  );

  get hideUnneededPages$(): Observable<boolean> {
    return this._hideUnneededPages.asObservable();
  }

  get hideUnneededPages(): boolean {
    return this._hideUnneededPages.getValue();
  }

  setHideUnneededPages(hide: boolean): void {
    this._hideUnneededPages.next(hide);
    localStorage.setItem(STORAGE_KEY, String(hide));
  }

  private readInitialValue(): boolean {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === 'true';
  }
}
